<div class="app-form-field-info-wrapper">
  <span class="app-form-field-info"><ng-content></ng-content></span>
</div>
